import script from "./WhereWeStart.vue?vue&type=script&setup=true&lang=js"
export * from "./WhereWeStart.vue?vue&type=script&setup=true&lang=js"

import "./WhereWeStart.vue?vue&type=style&index=0&id=13c2b42b&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c2b42b"]])

export default __exports__